import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Star } from '@root/shared/ui-kit'

import { toggleFavoritePairAction } from '../../atoms'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  size?: number
} & ClassNameProps

export const FavoriteStar: React.FC<Props> = ({
  pair,
  className,
  size = 20,
}) => {
  const toggleFavoritePair = useAction(toggleFavoritePairAction)
  const [isFavorite] = useAtom(pair.favorite)

  const handleFavoriteClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.stopPropagation()
    e.preventDefault()
    toggleFavoritePair({ pair })
  }

  return (
    <Root type="button" onClick={handleFavoriteClick} className={className}>
      <Star filled={isFavorite} size={size} />
    </Root>
  )
}

const Root = styled.button`
  all: unset;
  color: var(--amber-10);

  display: grid;
  place-items: center;

  cursor: pointer;
`
